// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"6ca19970c875f7a3","7170":"af3deeb3e9653e18","9361":"af3deeb3e9653e18"}[chunkId] + ".css";
};